<template>
  <draggable
    v-model="reorderableItems"
    animation="200"
    draggable=".reorderable-list button.reorderable-item"
    class="reorderable-list"
    data-test="draggable-reorderable-list"
    @start="dragging = true"
    @end="dragging = false"
  >
    <transition-group
      tag="div"
      class="list-group"
      type="transition"
      :name="transitionName"
      data-test="transition-group-reorderable-list"
    >
      <b-list-group-item
        v-for="item in items"
        :key="item.key"
        :data-test="`list-item-reorderable-list-${item.key}`"
        :variant="item.key === selected ? 'primary' : ''"
        button
        class="reorderable-item p-0"
        @click="onSelectedItem(item.key)"
      >
        <span
          :data-test="`span-reorderable-list-${item.key}`"
          class="d-block list-group-item-padding"
        >
          <font-awesome-icon
            icon="grip-vertical"
            size="sm"
          /> {{ item.label }}
        </span>
      </b-list-group-item>
    </transition-group>
  </draggable>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { ReorderableListItem } from './ReorderableList'

import draggable from 'vuedraggable'

const components = {
  draggable,
}

const props = {
  items: Array as PropType<ReorderableListItem[]>,
  selected: String as PropType<ReorderableListItem['key']>,
}

@Component({ components })
export default class ReorderableList extends Vue.extend({ props }) {
  dragging = false

  get reorderableItems () {
    return this.items
  }

  set reorderableItems (newItems) {
    this.$emit('update:items', newItems)
  }

  get transitionName () {
    return this.dragging ? null : 'flip-list'
  }

  onSelectedItem (selectedKey: ReorderableListItem['key']) {
    this.$emit('update:selected', selectedKey)
  }
}

</script>

<style scoped>

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.list-group-item-padding {
  padding: 0.75rem 1.25rem;
}

</style>
